// extracted by mini-css-extract-plugin
export default {"dogoverview":"DogOverview_dogoverview__b4AvL","grid":"DogOverview_grid__-3aWe","cell":"DogOverview_cell__A0w+z"};